import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { MainComponent } from './components/main.component';
import { FooterComponent } from './footer/footer.component';


// routes
export const ROUTES: Routes = [
  // { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: '', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./home/home.module')['HomeModule']);  });}) },
  { path: 'admin', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./admin/admin-main.module')['AdminModule']);  });})},
  { path: 'account', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./account/account.module')['AccountModule']);  });})},
  { path: 'campaign', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./camp/camp.module')['CampModule']);  });})},
  { path: 'about', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./about/about.module')['AboutModule']);  });})},
  { path: 'faq', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./faq/faq.module')['FaqModule']);  });})},
  { path: 'compare', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./compare/compare.module')['CompareModule']);  });})},
  { path: 'features', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./features/features.module')['FeaturesModule']);  });})},
  { path: 'support', loadChildren: () => new Promise(function (resolve) {  (require as any).ensure([], function (require: any) {    resolve(require('./support/support.module')['SupportModule']);  });})},
];

@NgModule({
  declarations: [
    MainComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(ROUTES, {enableTracing: true})
  ],
  providers: [],
  bootstrap: [MainComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./app/app.module.ts